import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const InfoHintsContext = createContext(null);

export function InfoHintsProvider({ children }) {
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('fa_info_hints_enabled');
    if (saved === '0') setEnabled(false);
  }, []);

  useEffect(() => {
    localStorage.setItem('fa_info_hints_enabled', enabled ? '1' : '0');
  }, [enabled]);

  const value = useMemo(() => ({ enabled, setEnabled }), [enabled]);

  return <InfoHintsContext.Provider value={value}>{children}</InfoHintsContext.Provider>;
}

export function useInfoHints() {
  const ctx = useContext(InfoHintsContext);
  if (!ctx) throw new Error('useInfoHints must be used within InfoHintsProvider');
  return ctx;
}
